/* eslint-disable prettier/prettier */
import API_WEATHER from './config.js'
import API_NEARCODE from './config.js'
const nearcodeService = {
    async getWeather() {
        const response = await fetch(`${API_WEATHER}`, {
            method: "GET"
        });
        if (response.ok) {
            return response
        } else {
            // eslint-disable-next-line prettier/prettier
            throw Error(response)
        }
    },
    async getJobs() {
        const response = await fetch(`${API_NEARCODE}jobs`, {
            method: "GET"
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error
        }
    },

    async login(email, password) {
        const response = await fetch(`${API_NEARCODE}login`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify({
                email: email,
                password: password
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response)
        }
    },

    async getApplications() {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications`, {
            method: "GET",
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            return response
        }
    },

    async getAppSkills() {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications/all/skills`, {
            method: "GET",
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response)
        }
    },

    async getUsers() {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}users`, {
            method: "GET",
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response)
        }
    },

    async registerUser(username, email, password, confPassword) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}register`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                username: username,
                email: email,
                password: password,
                confPassword: confPassword
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response)
        }
    },

    async addJob(name, description, profile, offer, state) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}jobs`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                name: name,
                description: description,
                profile: profile,
                offer: offer,
                state: state
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response)
        }
    },

    async editUserType(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}edit/type/${id}`, {
            method: "PUT",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response)
        }
    },

    async editUserState(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}edit/state/${id}`, {
            method: "PUT",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response)
        }
    },

    async getCv(id) {
        let token = localStorage.getItem("token")
        await fetch(`${API_NEARCODE}applications/download/${id}`, {
            method: "GET",
            headers: {
                'authorization': 'Bearer ' + token
            },
            responseType: 'blob'
        }).then(res => res.blob()).then(blob => {
            let file = window.URL.createObjectURL(blob)
            window.open(file, 'blank')
        })
    },

    async editJobState(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}jobs/${id}/edit/state`, {
            method: "PUT",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async editCandidate(id, comments) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications/${id}/comment`, {
            method: "PUT",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                comments: comments
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async editInterest(id, interest) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications/${id}`, {
            method: "PUT",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                interest: interest
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async getSkills() {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}skills`, {
            method: "GET",
            headers: {
                'authorization': 'Bearer ' + token
            },
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async deleteUser(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}delete/${id}`, {
            method: "DELETE",
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async deleteCandidate(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications/${id}`, {
            method: 'DELETE',
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async deleteJob(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}jobs/${id}`, {
            method: "PUT",
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async deleteApplication(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications/${id}`, {
            method: "DELETE",
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async sendEmailCandidate(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications/${id}/sendEmail`, {
            method: "GET",
            headers: {
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async editPassword(id, oldPassword, newPassword, newPassword2) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}edit/password/${id}`, {
            method: "PUT",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token

            },
            body: JSON.stringify({
                oldPassword: oldPassword,
                newPassword: newPassword,
                newPassword2: newPassword2
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json)
        }
    },

    async postContent(title, description, titleEn, descriptionEn,img, idPage) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}content`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                title: title,
                description: description,
                titleEn: titleEn,
                descriptionEn: descriptionEn,
                img: img,
                idPage: idPage
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async getPages() {
        const response = await fetch(`${API_NEARCODE}pages`, {
            method: "GET",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async getContent() {
        const response = await fetch(`${API_NEARCODE}content`, {
            method: "GET",
            headers: {
                'Content-type': 'application/json; charset=utd-8',
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async deleteContent(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}content/${id}`, {
            method: "DELETE",
            headers: {
                'Content-type': 'application/json; charset=utd-8',
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async putContent(id, title, description, titleEn, descriptionEn, img) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}content/edit/${id}`, {
            method: "PUT",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                title: title,
                description: description,
                titleEn: titleEn,
                descriptionEn: descriptionEn,
                img: img,
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async addSkill(name) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}skills`, {
            method: "POST",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                name: name
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async deleteSkill(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}skills/${id}`, {
            method: "DELETE",
            headers: {
                'Content-type': 'application/json; charset=utf-8',
                'authorization': 'Bearer ' + token
            },
            body: JSON.stringify({
                id: id
            })
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async sendEmailAllCandidate(id) {
        let token = localStorage.getItem("token")
        const response = await fetch(`${API_NEARCODE}applications/${id}/all/sendEmail`, {
            method: "GET",
            headers: {
                'Content-type': 'application/json; charset=utd-8',
                'authorization': 'Bearer ' + token
            }
        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    },

    async addSkillsToCandidate(id, skills) {
        let formData = new FormData()
        formData.append("skills", JSON.stringify(skills))
        /* let token = localStorage.getItem("token") */
        const response = await fetch(`${API_NEARCODE}skills/add/${id}`, {
            method: "Post",
            body: formData

        })
        if (response.ok) {
            return response.json()
        } else {
            throw Error(response.json())
        }
    }
}

export default nearcodeService;